module.exports = __webpack_public_path__ + "img/mnemonic.7c3d34fc.svg";